module.exports = __webpack_public_path__ + "static/media/icon_phone.a7bc8568.svg";